export const EXCEL_RESERVED_SHEET_NAME = "History";

export function toReportPackageSheetName(title: string): string {
    return title.replace(/[/\\?*[\]:]/g, "").replace(/^['\s]+|['\s]+$/g, "");
}

export function toReportPackageSheetNameKey(title: string): string {
    return toReportPackageSheetName(title).toLowerCase();
}

export function isReservedReportPackageSheetName(title: string): boolean {
    return (
        toReportPackageSheetNameKey(title) ===
        EXCEL_RESERVED_SHEET_NAME.toLowerCase()
    );
}

export function findReportPackageSheetNameClashes(titles: string[]): number[] {
    const seenNames = new Set<string>();
    return titles.flatMap((title, index) => {
        const name = toReportPackageSheetNameKey(title);
        if (seenNames.has(name)) {
            return [index];
        }
        seenNames.add(name);
        return [];
    });
}
